type GoogleIdTokenPayload = {
	email?: string;
	email_verified?: boolean;
	name?: string;
	picture?: string;
	sub?: string;
};

const decodeBase64Url = (segment: string): string => {
	const base64 = segment.replace(/-/g, '+').replace(/_/g, '/');
	const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');

	if (typeof atob === 'function') {
		const binary = atob(padded);
		const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
		return new TextDecoder().decode(bytes);
	}

	return Buffer.from(padded, 'base64').toString('utf-8');
};

export const decodeGoogleIdToken = (idToken: string): GoogleIdTokenPayload => {
	try {
		const payload = idToken.split('.')[1];
		if (!payload) {
			return {};
		}
		return JSON.parse(decodeBase64Url(payload)) as GoogleIdTokenPayload;
	} catch {
		return {};
	}
};
